// @ts-nocheck
import './ResourcesLinks.scss';
import React from 'react';
import { cn } from '../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { ListLinks } from '@dataartdev/uikit/ListLinks';
import { generatePath } from 'react-router-dom';
import { PATH } from '../../../router';
import { useIntl } from 'react-intl';

export type Props = {};

export const cnResourcesLinks = cn('ResourcesLinks');

export const ResourcesLinks: React.FC<Props> = props => {
  const { columnI, columnII, text, title } = props || {};

  const { locale } = useIntl();

  return (
    <div className={cnResourcesLinks()}>
      <div className={cnResourcesLinks('Title')}>
        <div className={cnResourcesLinks('Inner')}>
          {title && (
            <Typography.Title as="h2" size="lg">
              {title}
            </Typography.Title>
          )}
          {text && (
            <Typography.Text
              as="p"
              size="m"
              className={cnResourcesLinks('Description')}
            >
              {text}
            </Typography.Text>
          )}
        </div>
      </div>
      <div className={cnResourcesLinks('Links')}>
        {columnI && (
          <ListLinks
            id={item => item.id}
            items={columnI}
            getPath={item =>
              generatePath(PATH.SERVICES_PAGE, {
                slug: item.slug,
                lang: locale === 'en' ? null : locale,
              })
            }
            getLabel={item => item.title}
          />
        )}
        {columnII && (
          <ListLinks
            id={item => item.id}
            items={columnII}
            getPath={item =>
              generatePath(PATH.SERVICES_PAGE, {
                slug: item.slug,
                lang: locale === 'en' ? null : locale,
              })
            }
            getLabel={item => item.title}
          />
        )}
      </div>
    </div>
  );
};
